const common = {
  available: 'Available',
  classes: 'Classes',
  excludes: 'Excludes',
  includes: 'Includes',
  no_data: 'No data',
  no_selection: 'No selection',
  all_selected: 'All selected',
  close: 'Close',
  search: 'Search',
  select: 'Select',
  selected: 'Selected',
  select_multiple: 'Select options',
  warehouses: 'Warehouses',
  category: 'Category',
  total: 'Total',
}

export default common
